import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import DirectionSnackbar from '../../../Components/Snackbar'
import ComboBox from 'Components/ComboBox'
import { makeGetRequest } from 'utils/api'
import { makePutRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
export default function AddRulesForm({ handleChange, label, selected }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = React.useState(false)
  const [categoryfi, setCategoryfi] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState({})

  const [createRules, setCreateRules] = React.useState({
    Regle: '',
    Ordre: '',
    SousCategorie: '',
    id: '',
  })
  const fetchCategoryfi = async () => {
    const { data } = await makeGetRequest('/api/Finance/Categoriesfi/', {}, true)

    let set = []
    let tem = []
    data.forEach((v) => {
      if (!tem.includes(v.SousCategorie)) {
        tem.push(v.SousCategorie)
        set.push({ label: v.SousCategorie, id: v.id })
      }
    })

    setCategoryfi(set)
  }
  useEffect(() => {
    if (selected && selected.length > 0) {
      let filtercat = categoryfi.filter((v) => createRules.SousCategorie === v.label)

      setSelectedCategory(filtercat[0])
    }
  }, [categoryfi, createRules])
  const fetchRules = async () => {
    const { data } = await makeGetRequest('/api/Finance/RulesCatFI/' + selected[0], {}, true)
    setCreateRules(data)
  }
  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })

  const handleClickOpen = () => {
    setOpen(true)
    fetchCategoryfi()
    if (selected && selected.length === 1) {
      fetchRules()
    } else if (selected && selected.length > 1) {
      alert(t('finance.categorisation.rules.form.selectOneToModify')) // LAP-733 (GE022)
      handleClose()
    }
  }
  const handleChange1 = (e) => {
    setCreateRules({ ...createRules, [e.target.name]: e.target.value })
  }
  const handelCategoryfi = (e) => {
    setCreateRules({ ...createRules, SousCategorie: e.label })
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    if (selected && selected.length >= 0) {
      let { data } = await makePutRequest('/api/Finance/add/rules/', createRules, {}, true)
      if (data === 'regle exists.') {
        setOpenSnak({
          open: true,
          color: 'error',
          message: t('finance.categorisation.rules.form.charsAlreadyUsed'), // LAP-733 (GE022)
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message:
              'Ces caractères sont déjà utilisés pour une affectation à une autre sous-catégorie ',
          })
        }, 2000)
      } else {
        setOpenSnak({
          open: true,
          color: 'success',
          message: t('finance.categorisation.rules.form.editSuccess'), // LAP-733 (GE022)
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message: t('finance.categorisation.rules.form.accountAddSuccess'), // LAP-733 (GE022)
          })
        }, 2000)
        handleChange()
        handleClose()
      }
    } else {
      let { data } = await makePostRequest('/api/Finance/add/rules/', createRules, {}, true)
      if (data === 'regle exists.') {
        setOpenSnak({
          open: true,
          color: 'error',
          message: t('finance.categorisation.rules.form.charsAlreadyUsed'), // LAP-733 (GE022)
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message:
              'Ces caractères sont déjà utilisés pour une affectation à une autre sous-catégorie ',
          })
        }, 2000)
      } else {
        setOpenSnak({
          open: true,
          color: 'success',
          message: t('finance.categorisation.rules.form.addSuccess'), // LAP-733 (GE022)
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message: t('finance.categorisation.rules.form.accountAddSuccess'), // LAP-733 (GE022)
          })
        }, 2000)
      }

      handleChange()
      handleClose()
    }
  }

  return (
    <div>
      {openSnack.open && <DirectionSnackbar message={openSnack.message} color={openSnack.color} />}
      <Button
        sx={{
          marginLeft: '5px',
          color: 'white',
          '&:hover': { color: 'black', backgroundColor: 'white' },
        }}
        onClick={handleClickOpen}
      >
        {label}
      </Button>
      <Dialog maxWidth="xs" open={open} onClose={handleClose}>
        <form onSubmit={handleSubmit}>
          <DialogTitle sx={{ color: 'black !important' }}>
            {label} {t('finance.categorisation.rules.form.ruleSuffix') /* LAP-733 (GE022) */}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              required
              value={createRules.Regle}
              name="Regle"
              label={t('finance.categorisation.rules.form.ifOperationContains') /* LAP-733 (GE022) */}
              type="text"
              id="name"
              onChange={handleChange1}
              fullWidth
              variant="standard"
            />
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              label={t('finance.categorisation.rules.form.order') /* LAP-733 (GE022) */}
              type="text"
              name="Ordre"
              value={createRules.Ordre}
              onChange={handleChange1}
              fullWidth
              variant="standard"
            />
            {selected && selected.length === 1 ? (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  handelCategoryfi(j)
                }}
                label={t('finance.categorisation.rules.form.assignSubcategory') /* LAP-733 (GE022) */}
                data={categoryfi}
                required={true}
                name="SousCategorie"
                selectedValue={selectedCategory}
              />
            ) : (
              <ComboBox
                handleAutoComplete={(e, j) => {
                  handelCategoryfi(j)
                }}
                label={t('finance.categorisation.rules.form.assignSubcategory') /* LAP-733 (GE022) */}
                data={categoryfi}
                required={true}
                name="SousCategorie"
              />
            )}
            {/* <TextField
              autoFocus
              margin="dense"
              onChange={handleChange1}
              label="Affecter la sous-catégorie"
              value={createRules.SousCategorie}
              type="text"
              required
              fullWidth
              name="SousCategorie"
              variant="standard"
            /> */}
          </DialogContent>
          <DialogActions>
            <Button type="submit">
              {t('finance.categorisation.rules.form.validate') /* LAP-733 (GE022) */}
            </Button>
            <Button onClick={handleClose}>
              {t('finance.categorisation.rules.form.cancel') /* LAP-733 (GE022) */}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
